module.exports = __webpack_public_path__ + "img/pexels.4cf7be1a.jpg";